import { AxiosResponseHeaders } from 'axios';
import { Account, AccountListResponseDTO, AccountList } from '../entities';

const accountsListResponseDTOToAccountsListAdapter = (
  data: AccountListResponseDTO,
  headers?: AxiosResponseHeaders,
): AccountList => {
  if (!data.body) {
    throw new Error();
  }

  const { summary, accounts } = data.body;

  const accountsArray = (accounts || []).reduce((acc, account) => {
    if (account.isEnabled) {
      const newAccount = new Account(
        account.accountId,
        account.accountNumber,
        account.alias,
        account.productDescription,
        account.currency,
        account.availableBalance,
        account.bookBalance,
        account.created,
        account.lastUpdated,
        account.accountRelationDescription,
        account.iban,
        account.isEnabled,
        account.productId,
        account.beneficiary,
      );
      acc.push(newAccount);
    }
    return acc;
  }, [] as Account[]);

  return new AccountList(summary, accountsArray);
};

export { accountsListResponseDTOToAccountsListAdapter };
